(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["superfoot-collection-navigation"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('pageswap', (event) => {
    if (!event.viewTransition) return;

    const destination = event.activation?.entry?.url;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isCollectionFilter = destination && new URL(destination).pathname.startsWith('/collections/');

    if (!isCollectionFilter || reducedMotion) {
      event.viewTransition.skipTransition();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["superfoot-reviews"] && !Shopify.designMode) return;
  try {
    
  const setupTestimonialMotion = (section) => {
    if (section.dataset.motionReady) return;
    section.dataset.motionReady = 'true';
    const cards = [...section.querySelectorAll('[data-sf-testimonial]')];
    const backdrop = section.querySelector('.sf-testimonials__backdrop');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let scheduled = false;
    const update = () => {
      scheduled = false;
      if (reducedMotion.matches) return;
      const rect = section.getBoundingClientRect();
      const range = window.innerHeight + rect.height;
      const progress = Math.max(-.5, Math.min(.5, (window.innerHeight - rect.top) / range - .5));
      cards.forEach((card, index) => {
        const speed = Number(card.dataset.speed || .6);
        const direction = index === 1 ? -1 : 1;
        card.style.setProperty('--sf-scroll-shift', `${progress * 90 * speed * direction}px`);
      });
      backdrop?.style.setProperty('--sf-backdrop-shift', `${-4 + progress * 10}vw`);
    };
    const requestUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  };
  const initTestimonialMotion = (root = document) => {
    root.querySelectorAll('[data-sf-testimonials]').forEach(setupTestimonialMotion);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTestimonialMotion());
  } else {
    initTestimonialMotion();
  }
  document.addEventListener('shopify:section:load', (event) => initTestimonialMotion(event.target));

  } catch(e) { console.error(e); }
})();
})();
